<template>
  <div v-loading="productsLoading">
    <product-table v-for="table in productTables"
                   :key="table.type"
                   :product-type="table.type"
                   :data="table.data"
                   :title="table.title"
                   @click-order="onOrderClick"
                   @click-more-details="onMoreDetailsClick"/>
    <product-details-modal v-if="showDetailsModal"
                           :show.sync="showDetailsModal"
                           :product="selectedProduct"
                           @close="showDetailsModal = false"
                           @buy-click="onBuyClick(selectedProduct)"/>
    <product-order-modal v-if="showOrderModal"
                         :show.sync="showOrderModal"
                         :key="selectedProduct.id"
                         :product="selectedProduct"/>
  </div>
</template>
<script>
  import ProductTable from './Webshop/WebshopProductTable'
  import ProductDetailsModal from './Webshop/ProductDetailsModal'
  import ProductOrderModal from './Webshop/ProductOrderModal'
  import _groupBy from 'lodash/groupBy'
  import ProductService from 'src/services/ProductService'

  export default {
    name: 'client-webshop',
    components: {
      ProductTable,
      ProductDetailsModal,
      ProductOrderModal
    },
    data () {
      return {
        productTypes: [
          {type: 'featured_employer', title: this.$t('products.type.featuredEmployer')},
          {type: 'credit', title: this.$t('products.type.credit')},
          {type: 'slot', title: this.$t('products.type.slot')},
          {type: 'contract', title: this.$t('products.type.contract')},
          {type: 'cpc', title: this.$t('products.type.CPC')},
          {type: 'cpc', title: this.$t('products.type.CPC')},
          {type: 'recruiter_seat', title: this.$t('products.type.recruiterSeat')}
        ],
        productsLoading: false,
        showDetailsModal: false,
        showOrderModal: false,
        products: [],
        selectedProduct: null
      }
    },
    computed: {
      productTables () {
        const allowedProducts = this.products.filter(p => p.amount)
        const productsByType = _groupBy(allowedProducts, 'product_type')
        const tablesProps = []

        let values = []
        for (let product of this.productTypes) {
          const currentProducts = productsByType[product.type] || []
          values.push(...currentProducts)
        }

        tablesProps.push({
          title: this.$t('products.type.jobPosting'),
          data: productsByType['job_posting'] || [],
          type: 'job_posting'
        })

        tablesProps.push({
          title: this.$t('products.type.other'),
          data: values,
          type: 'other'
        })

        return tablesProps
      }
    },
    methods: {
      findProduct (type, prodId) {
        return this.products.find(p => p.id === prodId)
      },
      onMoreDetailsClick (type, prodId) {
        this.selectedProduct = this.findProduct(type, prodId)
        this.showDetailsModal = true
      },
      onOrderClick (type, prodId) {
        this.selectedProduct = this.findProduct(type, prodId)
        this.onBuyClick(this.selectedProduct)
      },
      onBuyClick (product) {
        if (product.product_type === 'job_posting') {
          this.handleJobPostingProduct(product)
        } else {
          this.showDetailsModal = false
          this.showOrderModal = true
        }
      },
      handleJobPostingProduct ({id}) {
        this.$router.push({
          path: `/jobs/create`, query: {
            productId: id,
            clientId: this.$route.params.id
          }
        })
      },
      async loadProducts () {
        try {
          this.productsLoading = true
          let {data} = await ProductService.get({limit: 100})
          this.products = data
        } catch (e) {
          this.$message.error(this.$t('Product load error'))
        } finally {
          this.productsLoading = false
        }
      }
    },
    async created () {
      await this.loadProducts()
    }
  }
</script>
<style>
</style>
